import { useEffect, useState } from "react";

export const MOBILE_MEDIA_QUERY = "(max-width: 768px)";

const hasMatchMedia = () => typeof window !== "undefined" && typeof window.matchMedia === "function";

/**
 * 뷰포트가 모바일 폭인지 반환한다. window.matchMedia가 없으면(jsdom 등) false.
 * matchMedia의 change 이벤트를 구독해 회전/리사이즈 시 갱신한다.
 * @param {string} [query=MOBILE_MEDIA_QUERY]
 * @returns {boolean}
 */
export function useIsMobile(query = MOBILE_MEDIA_QUERY) {
  // 첫 렌더부터 실제 값으로 시작해 데스크톱 표 → 카드 깜빡임을 막는다
  const [isMobile, setIsMobile] = useState(() => hasMatchMedia() && window.matchMedia(query).matches);

  useEffect(() => {
    if (!hasMatchMedia()) return undefined;
    const mql = window.matchMedia(query);
    const handleChange = () => setIsMobile(mql.matches);
    handleChange(); // query 변경 또는 첫 렌더~구독 사이의 변화 반영

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleChange);
      return () => mql.removeEventListener("change", handleChange);
    }
    mql.addListener(handleChange); // 구형 Safari(14 미만) 폴백
    return () => mql.removeListener(handleChange);
  }, [query]);

  return isMobile;
}
